<template>
    <div class="customer-table-filter">
        <!-- Filter Conditions Section -->
        <div class="filter-conditions">
            <div
                class="filter-row"
                v-for="(filter, index) in clone"
                :key="`filter-${index}-${filter.fieldId}-${filter.operator}`"
            >
                <!-- Field seçme CustomPicker'ı -->
                <CustomPicker
                    v-model="clone[index].fieldId"
                    :items="availableFields"
                    idKey="_id"
                    labelKey="name"
                    :title="$t('message.field')"
                    :icon="getFieldIcon(filter.fieldId)"
                    style="width: 30%; margin-right: 8px"
                    @input="onFieldChange(filter, index)"
                />

                <!-- Operatör seçme CustomPicker'ı -->
                <CustomPicker
                    v-model="clone[index].operator"
                    :items="getOperators(filter)"
                    idKey="value"
                    labelKey="label"
                    title="Operator"
                    icon="filter_list"
                    style="width: 25%; margin-right: 8px"
                    :disabled="!filter.fieldId"
                    @input="onOperatorChange(filter, index)"
                />

                <!-- Value inputu -->
                <CustomPicker
                    v-if="isDropdownField(filter)"
                    :items="getFieldOptions(filter)"
                    idKey="value"
                    labelKey="label"
                    title="Value"
                    icon="filter_list"
                    style="width: 30%; margin-right: 8px"
                    v-model="clone[index].value"
                    :multiple="isMultipleDropdownField(filter)"
                />
                <component
                    v-else
                    :is="getValueInputComponent(filter)"
                    v-model="clone[index].value"
                    :options="getFieldOptions(filter)"
                    style="width: 30%; margin-right: 8px"
                    :placeholder="'Value'"
                    :disabled="!filter.operator"
                ></component>

                <!-- Silme butonu -->
                <a-button type="danger" icon="delete" @click="removeFilter(index)" />
            </div>
        </div>

        <!-- Add Condition ve Apply Filter Butonları -->
        <div class="filter-actions">
            <a-button type="dashed" icon="plus" @click="addFilter"> {{ $t("tables.addCondition") }}</a-button>
            <SupsisButton primary @click="applyFilter" style="float: right">
                {{ $t("tables.applyFilter") }}</SupsisButton
            >
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import { cloneDeep } from "lodash";
import { Input, Select, Checkbox, DatePicker, Button } from "ant-design-vue";
import CustomPicker from "@/components/pickers/CustomPicker.vue";
import SupsisButton from "@/views/Pages/Settings/components/SupsisButton.vue";

export default Vue.extend({
    name: "TableFilter",
    components: {
        "a-input": Input,
        "a-select": Select,
        "a-select-option": Select.Option,
        "a-checkbox": Checkbox,
        "a-date-picker": DatePicker,
        "a-button": Button,
        CustomPicker,
        SupsisButton,
    },
    props: {
        fields: {
            type: Array,
            required: true,
        },
        value: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            clone: [],
        };
    },
    watch: {
        value: {
            immediate: true,
            handler(newValue) {
                this.clone = cloneDeep(newValue);
            },
        },
    },
    computed: {
        availableFields() {
            return this.fields;
        },
    },
    methods: {
        addFilter() {
            const newFilter = {
                fieldId: null,
                operator: null,
                value: null,
            };
            this.clone.push(newFilter);
            this.clone = _.cloneDeep(this.clone);
        },
        removeFilter(index) {
            this.clone.splice(index, 1);
            this.clone = _.cloneDeep(this.clone);
        },
        onOperatorChange(filter, index) {
            filter.value = null;
            this.clone[index] = _.cloneDeep(filter);
            this.clone = _.cloneDeep(this.clone);
        },
        onFieldChange(filter, index) {
            filter.operator = null;
            filter.value = null;
            this.clone[index] = _.cloneDeep(filter);
            this.clone = _.cloneDeep(this.clone);
        },
        isDropdownField(filter) {
            const field = this.fields.find((f) => f._id === filter.fieldId);
            if (!field) return false;
            return field.fieldType === "dropdown" || field.fieldType === "select";
        },
        isMultipleDropdownField(filter) {
            const field = this.fields.find((f) => f._id === filter.fieldId);
            if (!field) return false;
            return this.$_.get(field, "options.dropdown.multiple", false);
        },
        getOperators(filter) {
            console.log(`getOperators`, filter);
            if (!filter.fieldId) return [];
            const field = this.fields.find((f) => f._id === filter.fieldId);
            const valueType = field.valueType;
            console.log(`getOperators`, { field, valueType });
            const operators = {
                string: [
                    { label: this.$t("message.contains"), value: "contains" },
                    { label: this.$t("message.equals"), value: "equal" },
                    { label: this.$t("message.notEquals"), value: "not_equal" },
                    { label: this.$t("message.startsWith"), value: "starts_with" },
                    { label: this.$t("message.endsWith"), value: "ends_with" },
                ],
                number: [
                    { label: this.$t("message.equals"), value: "equal" },
                    { label: this.$t("message.notEquals"), value: "not_equal" },
                    { label: this.$t("message.greaterThan"), value: "greater_than" },
                    { label: this.$t("message.lessThan"), value: "less_than" },
                ],
                date: [
                    { label: this.$t("message.before"), value: "before" },
                    { label: this.$t("message.after"), value: "after" },
                ],
                boolean: [
                    { label: this.$t("message.is"), value: "equal" },
                    { label: this.$t("message.isNot"), value: "not_equal" },
                ],
                asset: [
                    { label: this.$t("message.empty"), value: "empty" },
                    { label: this.$t("message.notEmpty"), value: "not_empty" },
                ],
                dropdown: [
                    { label: this.$t("message.contains"), value: "contains" },
                    { label: this.$t("message.equals"), value: "equal" },
                    { label: this.$t("message.notEquals"), value: "not_equal" },
                    { label: this.$t("message.isOneOff"), value: "is_one_of" },
                ],
                array: [
                    { label: this.$t("message.contains"), value: "contains" },
                    { label: this.$t("message.equals"), value: "equal" },
                    { label: this.$t("message.notEquals"), value: "not_equal" },
                    { label: this.$t("message.isOneOff"), value: "is_one_of" },
                ],
                json: [
                    { label: this.$t("message.empty"), value: "empty" },
                    { label: this.$t("message.notEmpty"), value: "not_empty" },
                ],
            };

            const fallback = [
                { label: this.$t("message.empty"), value: "empty" },
                { label: this.$t("message.notEmpty"), value: "not_empty" },
            ];
            console.log(`getOperators last`, {
                operators,
                fallback,
                valueType,
                result: operators[valueType] || fallback,
            });
            return operators[valueType] || fallback;
        },
        getValueInputComponent(filter) {
            if (!filter.fieldId) return "a-input";

            const field = this.fields.find((f) => f._id === filter.fieldId);
            const fieldType = field.fieldType;
            const valueType = field.valueType;

            if (fieldType === "checkbox" || valueType === "boolean") {
                return "a-select";
            } else if (fieldType === "dropdown" || fieldType === "select") {
                return "a-select";
            } else if (valueType === "date") {
                return "a-date-picker";
            } else {
                return "a-input";
            }
        },
        getFieldOptions(filter) {
            const field = this.fields.find((f) => f._id === filter.fieldId);
            if (!field) return [];
            console.log(`getFieldOptions`, field);

            if (field.fieldType === "checkbox" || field.valueType === "boolean") {
                return [
                    { label: "True", value: true },
                    { label: "False", value: false },
                ];
            } else if (field.fieldType === "dropdown" || field.fieldType === "select") {
                // field.options şeklinde varsayıyorum
                const options = this.$_.get(field, "options.dropdown.options", []) || [];
                console.log(`getFieldOptions`, options);
                return options.map((opt) => ({ label: opt.value, value: opt.value }));
            } else {
                return [];
            }
        },
        applyFilter() {
            this.$emit("input", this.clone);
        },
        getSelectedFieldName(fieldId) {
            const field = this.fields.find((f) => f._id === fieldId);
            return field ? field.name : "";
        },
        getFieldIcon(fieldId) {
            const field = this.fields.find((f) => f._id === fieldId);
            if (!field) return "help_outline";

            switch (field.fieldType) {
                case "text":
                case "long-text":
                    return "text_fields";
                case "number":
                    return "looks_one";
                // ... diğer field tipleri için ikon atamalarını TableHeaders'daki gibi yapın
                default:
                    return "help_outline";
            }
        },
    },
});
</script>

<style scoped lang="scss">
.customer-table-filter {
    .filter-conditions {
        .filter-row {
            display: flex;
            align-items: center;
            margin-bottom: 8px;
            justify-content: space-between;
            gap: 10px;
        }
    }

    .custom-picker {
        width: max-content !important;
    }

    .filter-actions {
        margin-top: 16px;
    }
}
</style>
